module.exports = __webpack_public_path__ + "static/media/challenge_icon.b61623b5.svg";